import './LogbookListPage.css';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { logbookApi } from '../api/logbookApi';
import TopBar from '../components/TopBar';
import NewLogbookModal from '../components/NewLogbookModal';

const STATUS_CONFIG = {
  open: { label: 'Nyitott', color: '#39d353', bg: 'rgba(57, 211, 83, 0.12)', icon: 'ti-circle-check' },
  saved: { label: 'Mentett', color: '#d9a441', bg: 'rgba(217, 164, 65, 0.12)', icon: 'ti-pause' },
  closed: { label: 'Lezárt', color: '#9aa39a', bg: 'rgba(154, 163, 154, 0.12)', icon: 'ti-lock' },
};

const CATEGORY_ICONS = {
  'Egyéb / parkoló': 'ti-parking',
  'Felrakó': 'ti-package',
  'Lerakó': 'ti-package-export',
  'Vámkezelés': 'ti-stamp',
  'Tankolás': 'ti-gas-station',
};

export default function LogbookListPage() {
  const [logbooks, setLogbooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showNewModal, setShowNewModal] = useState(false);
  const navigate = useNavigate();

  const fetchLogbooks = async () => {
    try {
      const res = await logbookApi.list();
      setLogbooks(res.data);
    } catch (err) {
      setError('Nem sikerült betölteni a menetleveleket.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogbooks();
  }, []);

  const activeLogbooks = logbooks.filter(l => l.status !== 'closed');
  const closedLogbooks = logbooks.filter(l => l.status === 'closed');

  return (
    <div className="app-shell">
      <TopBar />
      <div className="app-content">
        <div className="page-header">
          <h1>Menetleveleim</h1>
          <button className="btn-new" onClick={() => setShowNewModal(true)}>
            <i className="ti ti-plus"></i> Új menetlevél
          </button>
        </div>

        {loading && <div className="loading-box">Betöltés...</div>}
        {error && <div className="error-box">{error}</div>}

        {!loading && activeLogbooks.length === 0 && closedLogbooks.length === 0 && (
          <div className="empty-state">
            <i className="ti ti-clipboard-off"></i>
            <p>Még nincs menetleveled.</p>
            <span>Nyiss egy újat a fenti gombbal!</span>
          </div>
        )}

        {activeLogbooks.length > 0 && (
          <>
            <h2 className="section-title">Aktív</h2>
            <div className="logbook-list">
              {activeLogbooks.map(lb => (
                <LogbookCard key={lb.id} logbook={lb} onClick={() => navigate(`/logbook/${lb.id}`)} />
              ))}
            </div>
          </>
        )}

        {closedLogbooks.length > 0 && (
          <>
            <h2 className="section-title">Lezárt</h2>
            <div className="logbook-list">
              {closedLogbooks.map(lb => (
                <LogbookCard key={lb.id} logbook={lb} onClick={() => navigate(`/logbook/${lb.id}`)} />
              ))}
            </div>
          </>
        )}
      </div>

      {showNewModal && (
        <NewLogbookModal
          onClose={() => setShowNewModal(false)}
          onCreated={(newLogbook) => {
            setShowNewModal(false);
            navigate(`/logbook/${newLogbook.id}`);
          }}
        />
      )}
    </div>
  );
}

function LogbookCard({ logbook, onClick }) {
  const statusCfg = STATUS_CONFIG[logbook.status];
  const lastEntry = logbook.last_entry;

  return (
    <div className="logbook-card" onClick={onClick}>
      <div className="logbook-card-top">
        <div>
          <div className="logbook-vehicle">
            <i className="ti ti-truck"></i>
            {logbook.vehicle_plate}
          </div>
          <div className="logbook-identifier">{logbook.identifier}</div>
        </div>
        <span className="status-badge" style={{ color: statusCfg.color, background: statusCfg.bg }}>
          <i className={`ti ${statusCfg.icon}`}></i>
          {statusCfg.label}
        </span>
      </div>

      {lastEntry && (
        <div className="logbook-card-body">
          <i className={`ti ${CATEGORY_ICONS[lastEntry.category] || 'ti-map-pin'} entry-icon`}></i>
          <div className="entry-info">
            <span className="entry-category">{lastEntry.category}</span>
            <span className="entry-city">{lastEntry.city}</span>
          </div>
          <div className="entry-km">{lastEntry.km?.toLocaleString('hu-HU')} km</div>
        </div>
      )}

      <div className="logbook-card-footer">
        <i className="ti ti-chevron-right"></i>
      </div>
    </div>
  );
}